import { render } from "./BindAccountDialog.vue?vue&type=template&id=2b6ad8d0&scoped=true"
import script from "./BindAccountDialog.vue?vue&type=script&lang=js"
export * from "./BindAccountDialog.vue?vue&type=script&lang=js"

import "./BindAccountDialog.vue?vue&type=style&index=0&id=2b6ad8d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6ad8d0"]])

export default __exports__